
const localData = localStorage.getItem("loginuser");
export const LOCAL_USER = JSON.parse(localData);


export const LOCAL_MODE = localStorage.getItem('modeid') || "64f9c09a931b0b27da1689b2"
